import { KEYS } from 'src/app/shared/utils/constants/storage.constants';
import { LocalStorageService } from '../../storage/local-storage.service';
import { StorefrontPolicyModel } from './model/StorefrontPolicyModels';
import { Injectable } from '@angular/core';
import { GeoLocationService } from '../../geolocation.service';
import { getDeviceType } from 'src/app/shared/utils/deviceUtils';
import { AccountProfileService } from '../../evergent/account/account-profile.service';
import { AuthService } from '../../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class StorefrontPolicyService {
  constructor(
    private readonly localStorage: LocalStorageService,
    private readonly geoLocationService: GeoLocationService,
    private readonly authService: AuthService
  ) {}

  getPolicy(): StorefrontPolicyModel {
    const policy = new StorefrontPolicyModel();
    const selectedProfile = JSON.parse(
      this.localStorage.getItem(KEYS.SELECTED_PROFILE)
    );
    const pf = selectedProfile?.contactType?.toLowerCase()
      ? selectedProfile?.contactType?.toLowerCase()
      : 'profile';
    const lang = 'ta,te';
    const pl = this.authService.isLoggedIn()
      ? this.localStorage.getItem(KEYS.PREFERRED_LANGUAGES) ||
        this.localStorage.getItem(KEYS.DL_PREFERRED_LANGUAGES)
      : this.localStorage.getItem(KEYS.ANONYMOUS_PREFERRED_LANGUAGES);

    policy.reg = this.geoLocationService.getRegion();
    policy.acl = lang;
    policy.itvod = true;
    policy.dt = getDeviceType().toString();
    policy.pf = pf;
    policy.pl = pl;
    return policy;
  }
}
